import React, { Component } from "react";
import {
  Alert,
  PermissionsAndroid,
  Platform,
  StyleSheet,
  Text,
  View,
  KeyboardAvoidingView,
} from "react-native";
import { WebView } from "react-native-webview";

import { Header, PulseLoader } from "../components";
import {
  setConsultation,
  APP_BASE_URL,
  BAYMAX_WIDGET_URL,
} from "../helpers/storage";
import _ from "lodash";
import { connect } from "react-redux";
import staticColors from "../constants/staticColors";
import fonts from "../constants/fonts";
import { STATIC_CARD_NUMBERS } from "../components/DependencyDetail";
import { API } from "../helpers/axios";
import { savePrescription } from "../helpers/saveImg";
import I18n from "i18n-js";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    position: "absolute",
    width: "100%",
    height: "100%",
  },
  content: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
    padding: 30,
  },
  message: {
    color: "#FFF",
    ...fonts.regular,
    fontSize: 20,
    padding: 40,
    paddingBottom: 10,
    textAlign: "center",
  },
  activityIndicator: {
    flex: 1,
    position: "absolute",
    width: "100%",
    height: "100%",
    backgroundColor: staticColors.grey,
  },
});

const duration = {
  day: "Hari",
  week: "Minggu",
  month: "Bulan"
}

class WaitingScreen extends Component {
  constructor(props) {
    super(props);

    this.messageIds = new Set();
    this.messages = [];

    this.state = {
      agentAvatar: "",
      doctor: null,
      room: null,
      temporaryRoom: null,
      isModalVisible: false,
      agent: null,
      messages: [],
      time: 0,
      loading: true,
    };
  }

  onCancel = () => {
    this.clearRoom(this.state.temporaryRoom);
  };

  finishConsultation = () => {
    this.props.navigation.replace("Rating", {
      transactionId: this.state.room.transaction_id,
      agentAvatar: this.state.doctorInfo.doctor_photo,
      agentName: `${this.state.doctorInfo.doctor_f_name} ${this.state.doctorInfo.doctor_l_name}`,
      agentSpecialities: this.state.doctorInfo.specialities[0].speciality_desc,
    });
  };

  onNavigationStateChange = (state) => {
    if (state.loading) {
      this.setState({
        loading: true,
      });
    } else {
      this.setState({
        loading: false,
      });
      if (Platform.OS === "android") {
        let permissions = [
          PermissionsAndroid.PERMISSIONS.CAMERA,
          PermissionsAndroid.PERMISSIONS.RECORD_AUDIO,
        ];

        PermissionsAndroid.requestMultiple(permissions).then((granted) => {
          const cameraGranted =
            granted["android.permission.CAMERA"] === "granted";
          const recordAudioGranted =
            granted["android.permission.RECORD_AUDIO"] === "granted";

          console.log({ cameraGranted, recordAudioGranted });
        });
      }
    }
  };

  onMessage = (event) => {
    const data = JSON.parse(event.nativeEvent.data);
    // console.log("onMessage", event, data);
    if (data.event === "endChat") {
      this.finishConsultation();
      setConsultation(null);
    }
    if (data.event === "download") savePrescription(data.data);
  };

  async createRoom() {
    // console.log("start create room");
    let responseData = null;

    const isStatic = STATIC_CARD_NUMBERS.includes(
      this.props.navigation.state.params.cardNumberDependency
    );

    const card_number_dependency = !isStatic
      ? this.props.navigation.state.params.cardNumberDependency
      : undefined;
    const dependent = isStatic
      ? this.props.navigation.state.params.cardNumberDependency
      : undefined;
    const dependency_full_name = !isStatic
      ? this.props.navigation.state.params.fullName
      : undefined;
    const symptoms = {
      complaint_id: this.props.navigation.state.params.complaintIds,
      consultation: this.props.navigation.state.params.consultation,
      duration: this.props.navigation.state.params.duration,
      duration_unit: this.props.navigation.state.params.durationUnit,
    };
    if (this.props.navigation.state.params.activeTransaction) {
      // console.log("resume transaction");
      responseData = {
        trx_id: this.props.navigation.state.params.transactionId,
        patient_id: this.props.navigation.state.params.newPatientId,
      };
    } else {
      // console.log("create new transaction");
      const {
        newPatientId: patient_id,
        inboxId: inbox_id,
        clientAppId: client_app_id,
        patientDob,
        hasDoB
      } = this.props.navigation.state.params;
      const payload = {
        inbox_id,
        patient_id,
        client_app_id,
        card_number_dependency,
        dependent,
        dependency_full_name,
        symptoms,
      };
      const patient_dob = patientDob
        ? `${patientDob.getFullYear()}-${
            patientDob.getMonth() + 1
          }-${patientDob.getDate()}`
        : null;
      
      if (!hasDoB) payload["patient_dob"] = patient_dob;
      
      try {
        const {
          data: { data },
        } = await API.post(`${APP_BASE_URL}/v2/consultations/start`, payload);
        responseData = { ...data, patient_id };
      } catch (error) {
        Alert.alert(
          "Gagal",
          "Tidak berhasil menghubungkan dengan dokter, coba lagi beberapa saat lagi."
        );
        console.log(error?.response || error);
      }
    }

    this.setState({
      temporaryRoom: responseData,
    });

    if (responseData) {
      this.checkRoom(responseData);
    }
  }

  sendMessage({ website_token, cw_token }) {
    const {
      consultation,
      duration,
      durationUnit,
      symptomsSummary,
      cardNumberDependency,
      fullName,
    } = this.props.navigation.state.params;
    let dependentMessage = "";
    if (STATIC_CARD_NUMBERS.includes(cardNumberDependency)) {
      dependentMessage = `Jenis Pasien: "Tertanggung tidak terdaftar"\n`;
    }
    if (cardNumberDependency) {
      dependentMessage = dependentMessage + `Pemeriksaan untuk: ${fullName}\n`;
    }

    const durationUnitTi18n = I18n.t(`prixa.${durationUnit}`);
    
    API.post(
      `${APP_BASE_URL}/v1/widgets/messages?website_token=${website_token}&cw_conversation=${cw_token}`,
      {
        message: {
          content: `${dependentMessage}Keluhan Utama: ${consultation}
          Lama keluhan: ${duration} ${durationUnitTi18n}
          Keluhan Tambahan: ${symptomsSummary || "-"}
          `,
          timestamp: new Date().toString(),
          "content-type": "text",
        },
      }
    ).catch((err) => console.log(err.response));
  }

  async clearRoom(roomData) {
    // console.log("cancel/finish consultation");
    if (roomData) {
      try {
        // cancel transaction (not in_progress state)
        await API.post(`${APP_BASE_URL}/v2/consultations/cancel`, {
          trx_id: roomData.trx_id,
        });
        await API.post(`${APP_BASE_URL}/v2/consultations/finish`, {
          trx_id: roomData.trx_id,
        });
      } catch (error) {
        console.log(error.response);
      }

      Alert.alert(
        "Timeout",
        "Tidak ada dokter yang tersedia, silakan coba beberapa saat lagi."
      );
    }

    this.props.navigation.goBack();
  }

  async getDoctorInfo(transaction) {
    try {
      const {
        data: { data: doctorInfo },
      } = await API.get(
        `${APP_BASE_URL}/v2/consultations/doctor-info?trx_id=${transaction.transaction_id}`
      );
      this.setState({ doctorInfo });
      console.log(doctorInfo);
    } catch (error) {
      console.log(error.response);
    }
  }

  checkRoom(roomData) {
    let time = 0;

    // start polling check transaction status
    this.pollingInterval = setInterval(() => {
      API.get(
        `${APP_BASE_URL}/v2/consultations/patient/${roomData.patient_id}?trxId=${roomData.trx_id}`
      ).then(({ data: { data: pollingResp } }) => {
        this.setState({
          time: time * 3,
        });

        // transaction get doctor
        if (pollingResp?.length > 0 && pollingResp[0].state === "in_progress") {
          console.log("doctor found, connecting to doctor", pollingResp);

          // send consultation if new transaction to message room
          if (
            this.props.navigation.state.params.consultation &&
            !this.props.navigation.state.params.activeTransaction
          ) {
            this.sendMessage(pollingResp[0]);
          }

          this.setState({ room: pollingResp[0] });
          this.getDoctorInfo(pollingResp[0]);
          clearInterval(this.pollingInterval);
        }

        // transaction didn't get doctor
        if (
          pollingResp?.length > 0 &&
          pollingResp[0].state === "doctor_not_found"
        ) {
          console.log("doctor not found, alert to cancel");
          this.clearRoom(roomData);
          clearInterval(this.pollingInterval);
        }

        // too long in progress state so canceled by system
        if (++time >= 20) {
          console.log("canceled by system");
          this.clearRoom(roomData);
          clearInterval(this.pollingInterval);
        }
      });
    }, 3000);
  }

  componentDidMount() {
    this.promise = this.createRoom();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    clearInterval(this.pollingInterval);
  }

  navigateCall = (callType) => {
    const { navigation } = this.props;
    const { agent, room } = this.state;
    navigation.navigate(callType, {
      doctor: {
        fullName: agent["username"],
      },
      patient: {
        id: navigation.state.params.patientId,
      },
      transaction: {
        id: room["trx_id"],
      },
    });
  };

  getBaymaxWidgetURL() {
    const { website_token, transaction_id } = this.state.room;
    return `${BAYMAX_WIDGET_URL}/website_token/${website_token}/transaction_id/${transaction_id}/access_token/${this.props.accessToken}`;
  }

  render() {
    let avatar;

    if (this.state.doctorInfo) {
      avatar = this.state.doctorInfo.doctor_photo;
    } else {
      avatar = require("../assets/avatars/doctor.png");
    }

    const {
      enableVoiceCall,
      enableVideoCall,
    } = this.props.navigation.state.params;

    // inject voximplant config to widget
    const injectJs = `window.voximplantConfig = {
      enableVoiceCall:${enableVoiceCall}, 
      enableVideoCall:${enableVideoCall}
    }`;

    const foreground = (msg) => (
      <View
        style={[
          styles.container,
          { backgroundColor: this.props.themeColors.primary },
        ]}
      >
        {this.state.time >= 10 && (
          <Header
            onPress={this.onCancel}
            position="start"
            text="Batal"
            theme="light"
          />
        )}
        <View style={styles.content}>
          <Text style={styles.message}>{msg}</Text>
          <PulseLoader avatar={avatar} />
        </View>
      </View>
    );

    if (this.state.room) {
      const uri = this.getBaymaxWidgetURL();
      return (
        <React.Fragment>
          <KeyboardAvoidingView
            enabled
            contentContainerStyle={{ flex: 1 }}
            keyboardVerticalOffset={Platform.select({
              ios: -50,
              android: 20,
            })}
            style={{ flexGrow: 1 }}
          >
            <WebView
              onNavigationStateChange={this.onNavigationStateChange}
              source={{ uri }}
              style={{ flex: 1 }}
              originWhitelist={["https://*"]}
              onMessage={(e) => this.onMessage(e)}
              allowsInlineMediaPlayback
              mediaPlaybackRequiresUserAction={false}
              injectedJavaScript={injectJs}
            />
          </KeyboardAvoidingView>

          {this.state.loading && this.state.doctorInfo
            ? foreground(
                `Anda terhubung dengan ${this.state.doctorInfo.doctor_f_name} ${this.state.doctorInfo.doctor_l_name}, sedang memuat percakapan.`
              )
            : null}
        </React.Fragment>
      );
    } else {
      return foreground(
        "Tunggu Sebentar ya, Kami sedang mencarikan Dokter untuk Anda"
      );
    }
  }
}

export default connect((state) => ({
  fcmToken: state.token.fcmToken,
  themeColors: state.themeColors,
  accessToken: state.token.accessToken,
}))(WaitingScreen);
